import m from "./../../../dist/es2015/themes/Nord.js";
export const am5themes_Nord = m;